export default __webpack_public_path__ + "static/media/apple-insha-bangles-icon.21959926.png";